import { Assignment, ContactAssignee, JobAssigneeRelationship } from '@eigtech/assignments-types'
import { corrupt } from 'exhaustive'

export function getJobAssignee<Assignee extends JobAssigneeRelationship>(
  assignments: Assignment[] | undefined,
  assigneeType: Assignee
): GetJobAssigneeReturn<Assignee> | undefined {
  const assignee = assignments
    ?.filter((assignment) => assignment.assignable.assigneeRelationship === assigneeType)
    ?.map(({ assignee }) => assignee)

  switch (assigneeType) {
    case 'approver':
    case 'coordinator':
    case 'dispatcher':
    case 'primaryContact':
    case 'projectManager':
    case 'fieldTechnician':
    case 'subcontractor':
      return assignee?.[0] as GetJobAssigneeReturn<Assignee>

    default:
      corrupt(assigneeType)
  }
}

type SingleAssignee = ContactAssignee
// type MultiAssignee = ContactAssignee[]

// This should be easier if this issue is ever addressed
// https://github.com/microsoft/TypeScript/issues/33014
type GetJobAssigneeReturn<Assignee extends JobAssigneeRelationship> = Assignee extends 'approver'
  ? SingleAssignee
  : Assignee extends 'coordinator'
    ? SingleAssignee
    : Assignee extends 'dispatcher'
      ? SingleAssignee
      : Assignee extends 'primaryContact'
        ? SingleAssignee
        : Assignee extends 'projectManager'
          ? SingleAssignee
          : Assignee extends 'fieldTechnician'
            ? SingleAssignee
            : Assignee extends 'subcontractor'
              ? SingleAssignee
              : never

export const getJobApprover = (assignments: Assignment[] | undefined) =>
  getJobAssignee(assignments, 'approver')

export const getJobCoordinator = (assignments: Assignment[] | undefined) =>
  getJobAssignee(assignments, 'coordinator')

export const getJobDispatcher = (assignments: Assignment[] | undefined) =>
  getJobAssignee(assignments, 'dispatcher')

export const getJobPrimaryContact = (assignments: Assignment[] | undefined) =>
  getJobAssignee(assignments, 'primaryContact')

export const getJobProjectManager = (assignments: Assignment[] | undefined) =>
  getJobAssignee(assignments, 'projectManager')

export const getJobFieldTechnician = (assignments: Assignment[] | undefined) =>
  getJobAssignee(assignments, 'fieldTechnician')

export const getJobSubcontractor = (assignments: Assignment[] | undefined) =>
  getJobAssignee(assignments, 'subcontractor')
